import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=fc56cd4a&scoped=true&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"
import style0 from "./Header.vue?vue&type=style&index=0&id=fc56cd4a&prod&scoped=true&lang=css&"
import style1 from "./Header.vue?vue&type=style&index=1&id=fc56cd4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc56cd4a",
  null
  
)

export default component.exports